import {
  getImageProps as getNextImageProps,
  type ImageLoader,
  type ImageProps as NextImageProps
} from 'next/image'

export type ImageProps = Pick<
NextImageProps,
| 'src'
| 'alt'
| 'width'
| 'height'
| 'fill'
| 'sizes'
| 'quality'
| 'loading'
| 'priority'
| 'blurDataURL'
| 'placeholder'
| 'className'
| 'style'
>

const storyblokAssetHostnames = ['a.storyblok.com']

export const srcIsStoryblokAsset = (src: ImageProps['src']): boolean => {
  if (typeof src !== 'string') {
    return false
  }

  try {
    const srcUrl = new URL(src)
    return storyblokAssetHostnames.includes(srcUrl.hostname)
  } catch {
    return false
  }
}

const defaultQuality = 80

export const storyblokImageLoader: ImageLoader = ({ src, width, quality }) => {
  const imgQuality = quality ?? defaultQuality

  return `${src}/m/${width}x0/smart/filters:quality(${imgQuality}):no_upscale()`
}

export const getImageProps = (props: ImageProps):
ReturnType<typeof getNextImageProps> => getNextImageProps({
  ...props,
  loader: srcIsStoryblokAsset(props.src) ? storyblokImageLoader : undefined
})

export const createPreloadImage = (props: ImageProps):
{ src: string; imagesrcset?: string; imagesizes?: string } => {
  const { props: { src, sizes, srcSet } } = getImageProps(props)

  return {
    src,
    imagesrcset: srcSet,
    imagesizes: sizes
  }
}
